import { Stack, StackProps, Typography } from '@mui/material';
import { FC } from 'react';
import viatelLogoBlack from '@/assets/viatel_black.png';
import viatelLogoWhite from '@/assets/viatel_white.png';

type ViatelLogoProps = StackProps & {
  white?: boolean;
};

const ViatelLogo: FC<ViatelLogoProps> = ({ white, ...props }) => {
  return (
    <Stack
      direction='row'
      gap={1}
      alignItems='center'
      {...props}
      sx={{
        transition: '0.3s',
        opacity: 0.5,
        '&:hover': {
          opacity: 1
        },
        ...props.sx
      }}
    >
      <Typography variant='overline' color={white ? 'white' : 'text.primary'} lineHeight={1.5}>
        Powered by
      </Typography>
      <img src={white ? viatelLogoWhite : viatelLogoBlack} alt='logo' height='25rem' />
    </Stack>
  );
};

export default ViatelLogo;
